// extracted by mini-css-extract-plugin
export default {"inputReset":"InputLogin_inputReset__XEwK1","inputBorder":"InputLogin_inputBorder__XMn2r","error":"InputLogin_error__S5w2R","inputLine":"InputLogin_inputLine__CzLiE"};